import { ICommonFieldProps } from "../../../../interfaces";
const InputCell = (props: ICommonFieldProps) => {
  const { defaultValue, onChange } = props;
  return (
    <input
      className="input-field"
      defaultValue={defaultValue}
      onChange={onChange}
    />
  );
};

export default InputCell;
